import { observable } from '../symbol/observable.js';
import { isFunction } from './isFunction.js';

function isInteropObservable(input) {
    return isFunction(input[observable]);
}

export { isInteropObservable };
//# sourceMappingURL=isInteropObservable.js.map
